import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer" role="contentinfo">
      <div className="footer-content">
        {/* Left: product */}
        <div className="d-flex align-items-center gap-2 text-muted small">
          <span>&copy; {currentYear} <strong>Meylo</strong></span>
        </div>

        {/* Center: maker / brand */}
        <div className="d-flex align-items-center justify-content-center gap-2 text-muted small mt-1 mt-sm-0">
          <span className="d-none d-sm-inline opacity-75">Powered by</span>
          <span className="d-inline-flex align-items-center gap-1">
            <a
              href="https://ai-websolutions.com"
              target="_blank"
              rel="noopener noreferrer"
              className="d-inline-flex align-items-center gap-1 text-decoration-none footer-link"
            >
              <img
                src="https://www.ai-websolutions.com/assets/favicon.png"
                alt="AI Web Solutions"
                className="developed-by-logo"
              />
              <span className="fw-medium">AI Web Solutions</span>
            </a>
          </span>
        </div>

        {/* Right: links & version */}
        <div className="footer-links d-flex align-items-center justify-content-end gap-3 mt-2 mt-sm-0">
          <Link
            to="/privacy-policy"
            className="footer-link small text-decoration-none text-muted hover-text-primary transition-colors"
          >
            {t("privacy")}
          </Link>
          <Link
            to="/terms-of-service"
            className="footer-link small text-decoration-none text-muted hover-text-primary transition-colors"
          >
            {t("terms")}
          </Link>
          <span
            className="version-badge badge bg-secondary-subtle text-secondary rounded-pill px-2 fw-normal"
            style={{ fontSize: "0.7rem" }}
          >
            v1.0.0
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
